import type { MouseEvent } from 'react';
import { computeDayListPopoverPosition } from './calendarCellAnchor';

const BUTTON_CLASS = 'text-left text-[11px] font-medium text-gray hover:underline';

type MoreCellPublicationsButtonProps = Readonly<{
    day: Date;
    extra: number;
    onOpenDayList: (day: Date, top: number, left: number) => void;
}>;

export function MoreCellPublicationsButton({
    day,
    extra,
    onOpenDayList,
}: MoreCellPublicationsButtonProps) {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const { top, left } = computeDayListPopoverPosition(
            event.currentTarget.getBoundingClientRect(),
        );
        onOpenDayList(day, top, left);
    };

    return (
        <button type="button" className={BUTTON_CLASS} onClick={handleClick}>
            {extra} de plus…
        </button>
    );
}
